import React from "react";

import cx from "classnames";

import { IconMap } from "../Icon/IconMap";

import styles from "./SvgIcon.scss";

/**
 * Type definition for the available icon colors.
 */
export type IconColor =
  | ""
  | "fill-asphalt"
  | "fill-gray"
  | "fill-primary"
  | "fill-snow"
  | "fill-dove"
  | "fill-transparent-black"
  | "fill-system-green";

/**
 * Props for the SvgIcon component.
 */
export interface SvgIconProps {
  /**
   * The icon to display from the IconMap
   */
  icon: keyof typeof IconMap;
  /**
   * The color to apply to the icon
   */
  color: IconColor;
  /**
   * Additional CSS class names to apply to the icon
   */
  className?: string;
}

/**
 * A component that renders an SVG icon with customizable colors.
 */
export function SvgIcon({ color, icon, className }: SvgIconProps): JSX.Element {
  const svgClassName = cx(styles[color], className);
  const Icon = IconMap[icon];

  return (
    <svg
      className={svgClassName}
      viewBox="0 0 18 18"
      aria-hidden="true"
      data-testid="svg-icon"
    >
      <g>{Icon && <Icon />}</g>
    </svg>
  );
}

/**
 * Available colors for the SvgIcon component.
 */
export const COLORS: Record<string, IconColor> = {
  NONE: "",
  ASPHALT: "fill-asphalt",
  DARK_GRAY: "fill-gray",
  PRIMARY: "fill-primary",
  SNOW: "fill-snow",
  DOVE: "fill-dove",
  TRANSPARENT_BLACK: "fill-transparent-black",
  SYSTEM_GREEN: "fill-system-green",
};
